import { Capacitor } from '@capacitor/core';

/**
 * Platform detection utility for Capacitor native vs. web.
 * Uses Capacitor's built-in platform detection which checks whether the app
 * is running inside a native WebView container or a regular browser.
 *
 * @example
 * ```ts
 * import { isNativePlatform } from '../utils/platform';
 *
 * if (isNativePlatform()) {
 *   // Skip service worker registration, use popup auth, etc.
 * }
 * ```
 */

/** Whether the app is running inside a Capacitor native shell (iOS or Android). */
export function isNativePlatform(): boolean {
  return Capacitor.isNativePlatform();
}
